import { forwardRef } from "react";

import { useField } from "formik";
import { TextInput as NativeTextInput } from "react-native";
import { TextInput, TextInputProps } from "react-native-paper";

type Props = TextInputProps & { scrollToEnd?: () => void };
const MultilineInput = forwardRef<NativeTextInput, Props>(
  function MultilineInput(props, ref) {
    const { onChangeText, scrollToEnd, ...rest } = props;

    return (
      <TextInput
        ref={ref}
        multiline={true}
        mode="outlined"
        numberOfLines={3}
        autoCorrect={false}
        scrollEnabled={false}
        onChangeText={(text) => {
          onChangeText && onChangeText(text);
          scrollToEnd && scrollToEnd();
        }}
        onFocus={scrollToEnd}
        {...rest}
      />
    );
  }
);

export default MultilineInput;

type FormikProps = Omit<Props, "value" | "onChange" | "onChangeText"> & {
  fieldName: string;
};

export function FormikMultilineInput({ fieldName, ...props }: FormikProps) {
  const [field] = useField<string>(fieldName);

  return (
    <MultilineInput
      {...props}
      value={field.value}
      onChangeText={field.onChange(fieldName)}
      onBlur={field.onBlur(fieldName)}
    />
  );
}
